import { createAction } from 'redux-actions'

export const clearPartnershipQuestion = createAction(
  'CLEAR_PARTNERSHIP_QUESTION'
)

export const setSummarySchool = createAction('SET_SUMMARY_SCHOOL')
